/* file description */
import { Modal, Input, Tooltip, Button, Select } from 'antd';
import React, { FC, useEffect, useState, useRef } from 'react';
import { getOpenApiData } from '@/common/asset-apis/assetModel';
import { useSetLabel, useGetLabelByEdit, useFetchData } from './effect';
import { COLUMN_FROM } from '../../effects/consts';
import { RecordSelectLinkShowModalProps } from './type';
import memo from '../memo';

const { Search } = Input;

export const OpenApiSelect: FC<RecordSelectLinkShowModalProps> = ({
  API,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  storeValue,
  rowsData,
  disabled,
  allowClear,
}) => {
  const [status, setStatus] = useState<any>('');
  const { value: fieldName, options = [], openApiUrl, isOpenSearch } = field?.options || {};

  const { optionList, setOptionList } = useSetLabel();
  // useGetLabelByEdit({ value, field, form, config, columnFrom, API });
  const { handleSearch } = useFetchData({ setOptionList, API, field });

  // let fieldError: any[];
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   const tableValid = form.getFieldsError().find((item: any) => item.name[0] === config.rowIndex && item.name[1] === field.name);
  //   fieldError = tableValid?.errors || [];
  // } else {
  //   fieldError = form.getFieldError(field.name);
  // }

  // useEffect(() => {
  //   if (fieldError?.length > 0) {
  //     setStatus('error');
  //   } else {
  //     setStatus('');
  //   }
  // }, [fieldError]);

  const selectVal = async (val: any) => {
    let findDictItem: Record<any, any> = {};
    if (isOpenSearch) {
      if (val) {
        const serachData = optionList?.find((item: Record<any, any>) => item[field?.options?.value] === val) || {};
        const companyType = serachData?.companyType || 1;
        const url = field?.options?.openApiUrl.replace('${value}/${type}', `${val}/${companyType}`);
        const res = await getOpenApiData(API.FetchAPI, 'get', url);
        findDictItem = res?.result || {};
      }
    } else {
      findDictItem = optionList?.find((item: Record<any, any>) => item[field?.options?.value] === val) || {};
    }
    options.forEach((item: { moduleField: any; linkField: any }) => {
      const values: Record<any, any> = {};
      if (columnFrom === COLUMN_FROM.FORM) {
        values[item.moduleField] = findDictItem?.[item.linkField];
        form.setFieldsValue(values);
      }
      if (columnFrom === COLUMN_FROM.TABLE) {
        const tableKey = config.rowIndex;
        values[tableKey] = {};
        values[tableKey][item.moduleField] = findDictItem?.[item.linkField];
        form.setFieldsValue(values);
      }
    });
    onChange?.(val);
  };

  return (
    <>
      <Select
        style={{ width: '100%', minWidth: '100px' }}
        status={status}
        showSearch
        showArrow={false}
        filterOption={false}
        onSearch={handleSearch}
        onChange={(val) => selectVal(val)}
        notFoundContent="请直接录入搜索"
        value={value}
        options={optionList}
        fieldNames={{
          label: field?.options?.label,
          value: field?.options?.value,
        }}
        allowClear={allowClear !== false}
        disabled={disabled}
      />
    </>
  );
};
export default memo(OpenApiSelect);
